import { Dialog, DialogTitle, DialogContent, DialogActions, Typography, Box } from '@material-ui/core'
import { format } from 'date-fns'
import { customTheme } from '../../../../styles/customTheme'
import { ExecucaoCiclo, TipoEnvioCiclo } from '../../../../types'
import { Botao } from '../../../Botao'

interface ModalConfirmacaoValidacaoProps {
  open: boolean
  execucao: ExecucaoCiclo | null
  tipoAcao: 'aceitar' | 'rejeitar' | null
  onClose: () => void
  onConfirmar: (cicloId: number, envio: TipoEnvioCiclo) => void | Promise<void>
  loading?: boolean
}

export function ModalConfirmacaoValidacao({ open, execucao, tipoAcao, onClose, onConfirmar, loading = false }: ModalConfirmacaoValidacaoProps) {
  if (!execucao || !tipoAcao) return null

  const formatarData = (data?: Date | string | null) => {
    if (!data) return 'N/A'
    return format(new Date(data as any), 'dd/MM/yyyy HH:mm')
  }
  const getTitulo = () => {
    return tipoAcao === 'aceitar' ? 'Confirmar Aprovação' : 'Confirmar Rejeição'
  }

  const getMensagem = () => {
    return `Tem certeza que deseja ${tipoAcao === 'aceitar' ? 'aprovar' : 'rejeitar'} a execução do ciclo ${execucao.cicloId}?`
  }

  const getTextoBotao = () => {
    return tipoAcao === 'aceitar' ? 'Aprovar' : 'Rejeitar'
  }

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        <Typography variant="h6" style={{ color: customTheme.colors.grey23 }}>
          {getTitulo()}
        </Typography>
      </DialogTitle>
      <DialogContent>
        <Box mt={2}>
          <Typography variant="body1" style={{ color: customTheme.colors.grey23 }}>
            {getMensagem()}
          </Typography>
          <Box mt={2}>
            <Typography variant="body2" style={{ color: customTheme.colors.grey08 }}>
              <strong>Detalhes da execução:</strong>
            </Typography>
            <Typography variant="body2" style={{ color: customTheme.colors.grey08 }}>
              - Tipo de Envio: {execucao.tipoEnvio === 1 ? 'Planilha' : 'API'}
            </Typography>
            <Typography variant="body2" style={{ color: customTheme.colors.grey08 }}>
              - Data Início: {formatarData(execucao.dataInicialAjustada ? execucao.dataInicialAjustada : execucao.dataInicialOriginal)}
            </Typography>
            <Typography variant="body2" style={{ color: customTheme.colors.grey08 }}>
              - Data Fim: {formatarData(execucao.dataFinalAjustada ? execucao.dataFinalAjustada : execucao.dataFinalOriginal)}
            </Typography>
          </Box>
        </Box>
      </DialogContent>
      <DialogActions>
        <Botao textoBotao="Cancelar" estilo="text" cor="primaria" onClick={onClose} disabled={loading} />
        <Botao
          textoBotao={getTextoBotao()}
          estilo="contained"
          cor="primaria"
          onClick={() => onConfirmar(execucao.cicloId, execucao.tipoEnvio)}
          disabled={loading}
        />
      </DialogActions>
    </Dialog>
  )
}
